/* eslint-disable no-new */
import Axios from 'axios';
import Request from 'classes/Request';
import debounce from 'lodash.debounce';
import AppMixin from 'mixins/App';
// import SimpleBreakpoints from 'simple-breakpoints';
import vClickOutside from 'v-click-outside';
import Vue from 'vue';
import App from './AppHydrated';
import store from './store';

// let breakpoints = new SimpleBreakpoints({
//   mobile: 480,
//   tablet: 768,
//   small_desktop: 768,
//   large_desktop: 1100,
// });

Vue.use(vClickOutside);
Vue.use(Request);

Vue.config.productionTip = false;

// Intercepteur pour les réponse json
Axios.interceptors.response.use((response) => {
  // Si on doit avoir un json, mais qu'il n'est pas valide
  if (response.headers['content-type'] === 'application/json' && !(response.data instanceof Object)) {
    throw new Error('Invalid response: wait json data');
  }
  // Sinon retourne la réponse normalement
  return response;
});

// Si mode development
if (process.env.NODE_ENV === 'development') {
  // Active debug Vue
  Vue.config.devtools = true;
  Vue.config.performance = true;
} else {
  Vue.config.devtools = false;
  Vue.config.debug = false;
  Vue.config.silent = true;
}

// Définit les données globales de l'instance
Vue.mixin(AppMixin);

for (let dsioApp of document.getElementsByClassName('dsio-app')) {
  const instanceId = dsioApp.id.replace('Dsio-', '');
  let instance = Object.freeze(Object.assign({}, window.__DSIO__[instanceId]));

  new Vue({
    el: dsioApp,
    components: { App },
    instanceId,
    data () {
      return {
        // Get instance data
        instance,
        breakpoint: null,
        windowWidth: null,
        appWidth: document.getElementById(dsioApp.id).offsetWidth,
        scrollInApp: false,
        scrollUp: false,
      };
    },
    created () {
      this.$store.dispatch('addInstance', {
        instanceId,
        app: this.instance.app,
      });

      // changement de taille pour les breakpoints
      window.addEventListener('resize', debounce(() => {
        this.updateBreakpoints(window.innerWidth);
      }, 100));
      this.updateBreakpoints(window.innerWidth);

      // Check scroll pour sticky,etc,...
      const dsioAppLocal = dsioApp;
      let lastScrollTop = 0;
      window.addEventListener('scroll', debounce(() => {
        // si scroll est dans l'app
        this.scrollInApp = this.updateInContainer(window.scrollY, dsioAppLocal);

        // Scroll up ou down
        const st = window.pageYOffset || document.documentElement.scrollTop;
        this.scrollUp = st < lastScrollTop;
        lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
      }, 20));
    },
    methods: {
      /**
       * retourne si le user scroll est dans l'app
       * @param windowTop
       * @param appEl
       * @returns {boolean}
       */
      updateInContainer (windowTop, appEl) {
        return (windowTop + 200 > appEl.offsetTop && windowTop + window.innerHeight < appEl.offsetTop + appEl.offsetHeight - 100);
      },
      /**
       * Mise à jour des breakpoints
       * @param width
       */
      updateBreakpoints (width) {
        this.windowWidth = width;

        const useAppWidth = this.appWidth < width;

        width = useAppWidth ? this.appWidth : width; // prend le conteneur de l'app comme référence

        if (width <= 480) { // mobile
          this.breakpoint = 'mobile';
        } else if (width <= 768) { // tablet
          this.breakpoint = 'tablet';
        } else if (width <= 1100) { // small_desktop
          this.breakpoint = 'small_desktop';
        } else if (width <= 1600) { // large_desktop
          this.breakpoint = 'large_desktop';
        } else { // very_large_desktop
          this.breakpoint = 'very_large_desktop';
        }

        /* if (width > 1600) {
          this.breakpoint = 'very_large_desktop';
        } else {
          this.breakpoint = breakpoints.currentBreakpoint();
        } */
      },
    },
    render (createElement) {
      return createElement(App);
    },
    store,
  });
}
